<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Agregar nuevo" : "Actualizar" }} producto</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6" v-show="!this.addStock">

        <!-- Product Image -->
        <template v-if="dataImg">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive">
            <span class="text-danger text-sm" v-show="errors.has('product_image')">{{ errors.first('product_image') }}</span>
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*" name="product_image">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Actualizar imágen</vs-button>
            <!-- <vs-button type="flat" color="#999" @click="dataImg = null">Eliminar imágen</vs-button> -->
          </div>
          <!-- <div v-show="image_error" class="vs-alert con-icon"><i class="vs-icon notranslate icon-scale icon-alert material-icons null">new_releases</i><span class="text-danger text-sm">{{ image_error }}</span></div> -->
          <vs-alert v-show="image_error" color="danger" style="height: initial" icon-pack="feather" icon="icon-info">
            {{ image_error }}
          </vs-alert>
        </template>

        <!-- SKU -->
        <vs-input label="SKU" v-model="dataSku" class="mt-5 w-full" name="item-sku" v-validate="'max:50'" data-vv-as="SKU"/>
        <span class="text-danger text-sm" v-show="errors.has('item-sku')">{{ errors.first('item-sku') }}</span>

        <!-- NAME -->
        <vs-input label="Título" v-model="dataTitle" class="mt-5 w-full" name="item-title" v-validate="'required|max:50'" data-vv-as="Título"/>
        <span class="text-danger text-sm" v-show="errors.has('item-title')">{{ errors.first('item-title') }}</span>

        <!-- DESCRIPTION -->
        <div class=" mt-5">
          <label class="vs-input--label">Descripción</label>
          <vs-textarea class="w-full" v-model="dataDescription" name="item-description" v-validate="'required|max:500'" data-vv-as="Descripción"/>
          <span class="text-danger text-sm" v-show="errors.has('item-description')">{{ errors.first('item-description') }}</span>
        </div>

        <!-- CATEGORY -->
        <div class="mt-5">
          <label class="vs-input--label">Categoría</label>
          <v-select browserAutocomplete="off" autocomplete="off" v-model="dataCategory" :reduce="dataCategory => dataCategory.value" :options="category_choices" :clearable="false" v-validate="'required'" name="item-category" :dir="$vs.rtl ? 'rtl' : 'ltr'" data-vv-as="Categoría"/>
          <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>
        </div>

         <!-- PROVIDER -->
        <vs-input label="Proveedor" v-model="dataProvider" class="mt-5 w-full" name="item-provider" v-validate="'max:250'" data-vv-as="Proveedor"/>
        <span class="text-danger text-sm" v-show="errors.has('item-provider')">{{ errors.first('item-provider') }}</span>

        <!-- STATUS -->
        <div class="mt-5">
          <label class="vs-input--label">Estado</label>
          <v-select browserAutocomplete="off" autocomplete="off" v-model="dataStatus" :reduce="dataStatus => dataStatus.value" :options="status_choices" :clearable="false" v-validate="'required'" name="item-status" :dir="$vs.rtl ? 'rtl' : 'ltr'" data-vv-as="Estado"/>
          <span class="text-danger text-sm" v-show="errors.has('item-status')">{{ errors.first('item-status') }}</span>
        </div>

        <!-- PRICE -->
        <vs-input
          icon-pack="feather"
          icon="icon-dollar-sign"
          label="Precio"
          data-vv-as="Precio"
          v-model="dataPrice"
          class="mt-5 w-full"
          v-validate="{ required: true, regex: /\d+(\.\d+)?$/, min_value: 0, max_value: 99999 }"
          name="item-price" />
        <span class="text-danger text-sm" v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span>

        <!-- STOCK -->
        <!-- Manage stock -->
        <div class="mt-5">
            <label class="vs-input--label w-full">Stock limitado</label>
            <vs-switch
                v-model="dataStockControl"
                class="w-1/6 my-2"
                >
                <template #off>
                    No
                </template>
                <template #on>
                    Sí
                </template>
            </vs-switch>
        </div>

        <vs-input
          icon-pack="feather"
          icon="icon-package"
          label="Stock Actual"
          data-vv-as="Stock Actual"
          v-model="dataStock"
          class="mt-5 w-full"
          v-validate="{ required: dataStockControl, regex: /\d+(\.\d+)?$/, min_value: 0, max_value: 99999 }"
          v-show="dataStockControl"
          name="item-stock" />
        <span class="text-danger text-sm" v-show="errors.has('item-stock')">{{ errors.first('item-stock') }}</span>

        <!-- STOCK MIN-->
        <vs-input
          icon-pack="feather"
          icon="icon-package"
          label="Stock Mínimo"
          data-vv-as="Stock Mínimo"
          v-model="dataStockMin"
          class="mt-5 w-full"
          v-validate="{ regex: /\d+(\.\d+)?$/, min_value: 0, max_value: 99999 }"
          v-show="dataStockControl"
          name="item-stock-min" />
        <span class="text-danger text-sm" v-show="errors.has('item-stock-min')">{{ errors.first('item-stock-min') }}</span>

        <!-- Withdraw -->
        <div class="mt-5">
            <label class="vs-input--label w-full">Receptor Obligatorio</label>
            <vs-switch
                v-model="dataWithdraw"
                class="w-1/6 my-2"
                >
                <template #off>
                    No
                </template>
                <template #on>
                    Sí
                </template>
            </vs-switch>
            <p><span>Seleccione la opción <strong>"Sí"</strong> para obligar al comprador a indicar la persona que retirará el producto.</span></p>
        </div>

        <!-- Upload -->
        <div class="upload-img mt-5" v-if="!dataImg">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-alert v-show="image_error" color="danger" class="mt-5 mb-5" icon-pack="feather" icon="icon-info" style="height:initial;min-height:62px">{{ image_error }}</vs-alert>
          <vs-button @click="$refs.uploadImgInput.click()">Subir imagen</vs-button>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || loading" id="saveButton">Guardar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    },
    addStock: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    isSidebarActive(val) {
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        let { id, image, sku, title, description, id_category, price, cost, stock, stock_min, provider, status, withdraw, stock_control } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataTitle = title
        this.dataSku = sku ? sku : ''
        this.dataDescription = description
        this.dataCategory = id_category
        this.dataImg = this.$baseUrlImg + image
        this.dataPrice = price
        this.dataCost = cost
        this.dataStock = stock
        this.dataStockMin = stock_min
        this.dataProvider = provider ? provider : ''
        this.image_loaded = false
        this.image_error = ''
        this.dataCategoryId = id_category,
        this.dataStatus = status
        this.dataWithdraw = withdraw == 1 ? true : false
        this.dataStockControl = stock_control
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {
      loading: false,

      dataSku: "",
      dataTitle: "",
      dataDescription: "",
      dataCategory: null,
      dataStatus: 2,
      dataPrice: 0,
      dataStock: 0,
      dataStockMin: 0,
      dataProvider: '',
      dataImg: null,
      dataWithdraw: 0,
      dataStockControl: false,
      dataId: null,

      dataCategoryId: 0,

      product_image: {
        size: '',
        width: '',
        height: ''
      },

      image_loaded: false,
      image_error: '',

      category_choices: [],
      selected: [],

      status_choices: [
        {label: 'Inactivo', value: 0 },
        {label: 'Activo', value: 1 },
        {label: 'Publicado', value: 2 }
      ],

      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataTitle && this.dataDescription && this.dataCategory && (this.dataPrice >= 0) && this.dataPrice && (this.dataStockControl ? (this.dataStock > 0 && this.dataStockMin >= 0) : true) && this.image_error == '' && (this.dataId ? this.dataImg.length : this.image_loaded)
    },
  },
  methods: {
    initValues() {
      if(this.data.id) return
        this.dataId = null
        this.dataTitle = null
        this.dataSku = ''
        this.dataDescription = null
        this.dataCategory = null
        this.dataImg = null
        this.dataPrice = null
        this.dataCost = null
        this.dataStock = null
        this.dataStockMin = null
        this.dataProvider = null
        this.image_loaded = false
        this.image_error = ''
        this.dataCategoryId = null
        this.dataStatus = 2
        this.dataWithdraw = false
        this.dataStockControl = false
    },
    submitData() {
      if (this.addStock) {
        this.updateStock()
      } else {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.disableSaveButton();
            const obj = {
              id_product: this.dataId,
              id_store: this.$store.state.AppActiveUser.store.id,
              sku: this.dataSku,
              title: this.dataTitle,
              description: this.dataDescription,
              id_category: this.dataCategory,
              image: (this.image_loaded) ? this.dataImg : '',
              price: this.dataPrice,
              stock: this.dataStock,
              stock_min: this.dataStockMin ? this.dataStockMin : 0,
              provider: this.dataProvider,
              status: this.dataStatus,
              withdraw: this.dataWithdraw ? 1 : 0,
              stock_control: this.dataStockControl
            }

            if(this.dataId !== null && this.dataId >= 0) {
              this.updateProduct(obj)
            } else {
              delete obj.id_product
              // delete obj.status
              this.addProduct(obj)
            }
          }
        })
      }
    },
    addProduct(item) {
      this.$store.dispatch("marketplace/addProduct", item)
      .then(response => {
        this.$emit("showNotify",response.data.status)
        if(response.data.status) { this.closeSidebar() }
        this.enableSaveButton()
      })
      .catch(err => {
        this.$emit("showNotify", false, err)
        this.enableSaveButton();
      })
    },
    updateProduct(item) {
      this.$store.dispatch("marketplace/updateProduct", item)
      .then(response => {
        this.$emit("showNotify",response.data.status)
        if(response.data.status) { this.closeSidebar() }
        this.enableSaveButton()
      })
      .catch(err => {
        this.$emit("showNotify", false, err)
        this.enableSaveButton();
      })
    },
    closeSidebar() {
      this.$emit('closeSidebar')
      this.initValues()
    },
    disableSaveButton() {
      this.loading = true
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#saveButton",
        scale: 0.45
      })
    },
    enableSaveButton() {
      this.loading = false
      this.$vs.loading.close("#saveButton > .con-vs-loading")
    },
    updateCurrImg(input) {
      this.image_loaded = false;
      this.image_error = '';
      if (input.target.files && input.target.files[0]) {
        this.product_image.size = input.target.files[0].size;
        var reader = new FileReader()
        reader.onload = e => {
          let img = new Image();
          img.onload = () => {
            this.product_image.width = img.width;
            this.product_image.height = img.height;
            if (this.product_image.width != this.product_image.height || this.product_image.width > 300 || this.product_image.width < 120 ) {
              this.image_error = 'La imágen debe ser cuadrada (misma altura y ancho) con un máximo de 300px y un mínimo de 120px';
            } else {
              if (this.product_image.size > 100000){
                this.image_error = 'La imágen excede el tamaño máximo (100 KB).';
              } else {
                this.dataImg = e.target.result
                this.image_loaded = true;
              }
            }
          }
          img.src = e.target.result;
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updateStock() {
      if (this.modifyStock != 0) {
        const obj = {
          id: this.dataId,
          obs: this.obs,
          stock: Number(this.modifyStock)
        }
        this.disableSaveButton();
        this.$store.dispatch("dataList/addStock", obj)
        .then(response => {
          this.$emit("showNotify",response.data.status)
          this.enableSaveButton();
        })
        .catch(err => {
          this.$emit("showNotify", false, err);
          this.enableSaveButton();
        })

        this.$emit('closeSidebar')
        this.initValues()
      }

    },
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  created() {
    this.$store.dispatch("marketplace/getCategories", '')
    .then(response => {
      response.data.forEach(element => {
        if(element.status == 1)
          this.category_choices.push({label: element.name, value: element.id})
      });
    })
    .catch(error => {console.log(error)})
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
    p {
      margin-bottom: 2rem;
      > span {
        font-size: 0.9rem;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
